import { Link } from "react-router-dom";
import { Image, P } from "../../../../../../AbstractElements";
import { Href, MoreComments } from "../../../../../../Constants/Constants";
import { SocialChatData } from "../../../../../../Data/Applications/SocialApp/SocialApp";
import { dynamicImage } from "../../../../../../Utils";

const SocialChat = () => {
  return (
    <div className="social-chat">
      {SocialChatData.map((data, index) => (
        <div className={data.class} key={index}>
          <div className="d-flex">
            <Image className="img-50 img-fluid m-r-20 rounded-circle" alt="user" src={dynamicImage(`user/${data.image}`)} />
            <div className="flex-grow-1">
              <span className="f-w-600">
                {data.title}&nbsp;
                <span>
                  {data.year} <i className="fa fa-reply font-primary" />
                </span>
              </span>
              <P>{data.text}</P>
            </div>
          </div>
        </div>
      ))}
      <div className="text-center">
        <Link to={Href}>{MoreComments}</Link>
      </div>
    </div>
  );
};

export default SocialChat;
